import { VerifyEcoaAccessCodeRequest, VerifyEcoaAccessCodeResponse } from "./EcoaAccessCode.dto";
import { EcoaAccessCodeUrl } from "./EcoaAccessCode.url";
import { restReq } from "../../common/cyan.types";
import { FxApiRequestData, FxRequestData } from "../../common/flax.types";

export class EcoaAccessCodeFlax {
  public static verifyEcoaAccessCode(data: FxRequestData<VerifyEcoaAccessCodeRequest>): FxApiRequestData<VerifyEcoaAccessCodeResponse> {
    return {
      ...restReq(process.env.REACT_APP_CDMS_BE_URL, EcoaAccessCodeUrl.verifyEcoaAccessCode, data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }
}
